<template>
  <button class="btn btn-light like-btn" :aria-label="`Like`">
    <i class="icon icon-heart" />
    <i class="icon icon-heart-filled" />
  </button>
</template>

<script setup lang="ts">
defineOptions({
  name: "like-button",
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
